// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".badge[data-v-5a3f6ab0]{background-color:#fa3e3e;border-radius:2rem;color:#fff;padding:1px 5px;font-size:11px;position:absolute;top:-5px;right:-10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
